import { render, staticRenderFns } from "./commodityOrders.vue?vue&type=template&id=2ce9ea45&scoped=true"
import script from "./commodityOrders.vue?vue&type=script&lang=js"
export * from "./commodityOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce9ea45",
  null
  
)

export default component.exports